import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import './UniversalCTA.css';

// Universal "Find What Others Missed" CTA — a gold plaque that shares the
// shape of the Founders "You are not alone…" copper box, the foil-gold
// coloring of the CADENCE Promise "Finding Clarity in the Chaos" tile, and
// the gold edges of the "Problem We're Solving" plaque. Placed at the
// bottom of the public marketing pages.
const scrollToTop = () => window.scrollTo(0, 0);

const UniversalCTA = () => {
  return (
    <section className="universal-cta-section" data-testid="universal-cta-section">
      <div className="container">
        <div className="universal-cta-tile" data-testid="universal-cta-tile">
          <p className="universal-cta-heading">The Care You Deserve Starts Here</p>
          <Link
            to="/portal?guest=true&tab=intake"
            className="universal-cta-btn"
            onClick={scrollToTop}
            data-testid="universal-cta-btn"
          >
            Find What Others Missed
            <ArrowRight size={16} />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default UniversalCTA;
